const OrderNow = () => {
    return (
        <div>
            <h1>Order Now</h1>
        </div>
    )
}

export default OrderNow;
